(() => {
  document.querySelectorAll('[data-vp-merged-highlights]').forEach(panel => {
    if (panel.dataset.vpHighlightsReady) return;
    const section = panel.closest('.shopify-section');
    const order = section?.querySelector('#main-product');
    const dataNode = panel.querySelector('[data-vp-highlight-data]');
    if (!order || !dataNode) return;
    const data = JSON.parse(dataNode.textContent);
    const styleNode = panel.querySelector('[data-vp-highlight-style]');
    const list = panel.querySelector('[data-vp-highlight-list]');
    const finishNode = panel.querySelector('[data-vp-highlight-finish]');
    const sizeNode = panel.querySelector('[data-vp-highlight-size]');
    let signature = '';
    let scheduled = false;
    const selection = () => {
      if (order.dataset.vpMergedStyle) return {'card style': order.dataset.vpMergedStyle, finish: order.dataset.vpMergedFinish, size: order.dataset.vpMergedSize};
      const values = {};
      order.querySelectorAll('.swatch-single').forEach(group => {
        const name = group.querySelector('.swatch-option-name')?.textContent.trim().toLowerCase();
        const checked = group.querySelector('[role="radio"][aria-checked="true"]');
        if (name && checked) values[name] = checked.getAttribute('orig-value') || '';
      });
      order.querySelectorAll('input[type="radio"]:checked').forEach(input => {
        const name = ['card style', 'finish', 'size', 'size & finish'].find(name => input.name.toLowerCase().endsWith('-' + name + ']'));
        if (name && values[name] === undefined) values[name] = input.value;
      });
      return values;
    };
    function update() {
      const values = selection();
      const style = values['card style'] || data.initial.style;
      const profile = data.profiles.styles[style];
      if (!profile) return;
      const combined = values['size & finish'];
      const pieces = combined?.split(' / ');
      const finish = values.finish ?? (pieces?.length > 1 ? pieces.slice(1).join(' / ') : combined !== undefined ? '' : style === data.initial.style ? data.initial.finish : '');
      const size = values.size ?? pieces?.[0] ?? (style === data.initial.style ? data.initial.size : '');
      const selectedProfile = profile.finish_overrides?.[finish] || profile;
      const key = JSON.stringify([style, finish, size, selectedProfile.highlights]);
      if (key === signature) return;
      signature = key;
      styleNode.textContent = style;
      list.replaceChildren(...selectedProfile.highlights.map(text => {
        const item = document.createElement('li');
        item.textContent = text;
        return item;
      }));
      finishNode.hidden = !finish || finish === 'Standard';
      finishNode.textContent = data.labels.finish + ': ' + finish;
      sizeNode.hidden = !size;
      sizeNode.textContent = data.labels.size + ': ' + size;
      panel.dataset.vpSelectedStyle = style;
      panel.dataset.vpSelectedFinish = finish;
      panel.dataset.vpSelectedSize = size;
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    }
    new MutationObserver(schedule).observe(order, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-checked', 'checked', 'selected', 'data-vp-merged-style', 'data-vp-merged-finish', 'data-vp-merged-size'] });
    order.addEventListener('change', schedule);
    order.addEventListener('varaprint:merged-selection', schedule);
    window.addEventListener('popstate', schedule);
    panel.dataset.vpHighlightsReady = 'true';
    update();
  });
})();
